/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useStartupState } from '../../../../Providers/StartupState';
import { baseUrlImg, handleGetData } from '../../../../Api';
import { Loading } from '../../../../components/Loading';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import * as S from './style';

export const Corn = () => {
  const [data, setData] = useState(null);
  const [priceImg, setPriceImg] = useState();
  const [BgImg, setBgImg] = useState();

  const { token, setError, loading, setLoading } = useStartupState();

  useEffect(() => {
    setError(null);
    setLoading(true);
    if (token) {
      handleGetData(token, 'api/content/copasul/comercialdemilho')
        .then((response) => {
          setData(response?.data?.items[0]?.data);
          if (response?.status !== 200) {
            throw new Error(response.message);
          }
        })
        .catch((e) => {
          setData(null);
          console.log(e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [token]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 800) {
        setBgImg(data?.imagemBackgroundMobile?.iv[0]);
        return setPriceImg(data?.imagemCotacao?.iv[0]);
      } else if (window.innerWidth >= 800 && window.innerWidth <= 1100) {
        setBgImg(data?.imagemBackgroundWeb?.iv[0]);
        return setPriceImg(data?.imagemCotacao?.iv[0]);
      } else if (window.innerWidth > 1100) {
        setBgImg(data?.imagemBackgroundWeb?.iv[0]);
        return setPriceImg(data?.imagemCotacao?.iv[0]);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  if (loading) {
    return <Loading />;
  }
  if (data) {
    return (
      <S.Container src={`${baseUrlImg}${BgImg}`}>
        <section>
          <S.ListBox>
            <h2>{data?.seo?.iv?.TituloSEO}</h2>
            <ReactMarkdown children={data?.conteudoMarkdown?.iv} />
          </S.ListBox>
          <S.QuotationBox>
            <S.ImgBox>
              <img src={`${baseUrlImg}${priceImg}`} alt="Imagem explicativa do grão" />
            </S.ImgBox>
          </S.QuotationBox>
        </section>
      </S.Container>
    );
  }
};
